import * as React from 'react';
import {FunctionComponent} from 'react';

interface OwnProps {}

export const OutdoorGraphsPromo: FunctionComponent<OwnProps> = ({}) => {
    return (
        <div className="card mt-3">
            <div className="card-title">
                <h5>Graphs</h5>
            </div>
            <div className="card-body graphs">
                <div className="card-body-promo">
                    <p>Visualize your performance with Premium Graphing</p>
                    <p>
                        Take your outdoor workouts to the next level by creating detailed, customizable graphs of your
                        sessions. Track metrics like stroke rate, heart rate, speed, and more — all in one clear,
                        interactive view.
                    </p>
                    <p>
                        <b>Level up your training — become an Advanced Member today!</b>
                    </p>
                    <a href="/account/subscriptions/checkout" className="btn btn-primary">
                        Become an Advanced Member
                    </a>
                </div>
                <div className="row skeleton skeleton--opacity skeleton--static">
                    <div className="col-12">
                        <p className="graphs__label">
                            <span>Split (/500m)</span>
                        </p>
                        <div
                            className="VictoryContainer"
                            style={{
                                height: '100%',
                                width: '100%',
                                userSelect: 'none',
                                pointerEvents: 'none',
                                touchAction: 'none',
                                position: 'relative',
                            }}
                        >
                            <svg
                                width="450"
                                height="80"
                                role="img"
                                viewBox="0 0 450 80"
                                style={{pointerEvents: 'all', width: '100%', height: '100%'}}
                            >
                                <linearGradient id="heartrateGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" stopColor="#DC3545" stopOpacity="0.4"></stop>
                                    <stop offset="100%" stopColor="#DC3545" stopOpacity="0"></stop>
                                </linearGradient>
                                <g role="presentation">
                                    {/* Axes and grid lines */}
                                    <line
                                        x1="20"
                                        x2="450"
                                        y1="60"
                                        y2="60"
                                        style={{stroke: 'rgba(0, 0, 0, 0.1)', fill: 'transparent', strokeWidth: 1}}
                                    />
                                    {/* More lines and ticks as needed */}
                                </g>
                            </svg>
                            <div
                                style={{
                                    zIndex: 99,
                                    position: 'absolute',
                                    top: '0px',
                                    left: '0px',
                                    width: '100%',
                                    height: '100%',
                                }}
                            >
                                <svg
                                    width="450"
                                    height="80"
                                    viewBox="0 0 450 80"
                                    style={{overflow: 'visible', width: '100%', height: '100%'}}
                                >
                                    <g role="presentation">
                                        <line
                                            vectorEffect="non-scaling-stroke"
                                            role="presentation"
                                            shapeRendering="auto"
                                            x1="20"
                                            x2="20"
                                            y1="0"
                                            y2="60"
                                            style={{
                                                stroke: 'rgba(0, 0, 0, 0.1)',
                                                fill: 'transparent',
                                                strokeWidth: 1,
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'round',
                                            }}
                                        />
                                        <g role="presentation">
                                            <line
                                                vectorEffect="non-scaling-stroke"
                                                role="presentation"
                                                shapeRendering="auto"
                                                x1="20"
                                                x2="450"
                                                y1="60"
                                                y2="60"
                                                style={{
                                                    stroke: 'rgba(0, 0, 0, 0.1)',
                                                    strokeWidth: 1,
                                                    strokeDasharray: 4,
                                                    fill: 'none',
                                                    pointerEvents: 'painted',
                                                }}
                                            />
                                        </g>
                                        <g role="presentation">
                                            <line
                                                vectorEffect="non-scaling-stroke"
                                                role="presentation"
                                                shapeRendering="auto"
                                                x1="20"
                                                x2="450"
                                                y1="41.51162790697674"
                                                y2="41.51162790697674"
                                                style={{
                                                    stroke: 'rgba(0, 0, 0, 0.1)',
                                                    strokeWidth: 1,
                                                    strokeDasharray: 4,
                                                    fill: 'none',
                                                    pointerEvents: 'painted',
                                                }}
                                            />
                                        </g>
                                        <g role="presentation">
                                            <line
                                                vectorEffect="non-scaling-stroke"
                                                role="presentation"
                                                shapeRendering="auto"
                                                x1="20"
                                                x2="450"
                                                y1="23.02325581395349"
                                                y2="23.02325581395349"
                                                style={{
                                                    stroke: 'rgba(0, 0, 0, 0.1)',
                                                    strokeWidth: 1,
                                                    strokeDasharray: 4,
                                                    fill: 'none',
                                                    pointerEvents: 'painted',
                                                }}
                                            />
                                        </g>
                                        <g role="presentation">
                                            <line
                                                vectorEffect="non-scaling-stroke"
                                                role="presentation"
                                                shapeRendering="auto"
                                                x1="20"
                                                x2="450"
                                                y1="4.5348837209302335"
                                                y2="4.5348837209302335"
                                                style={{
                                                    stroke: 'rgba(0, 0, 0, 0.1)',
                                                    strokeWidth: 1,
                                                    strokeDasharray: 4,
                                                    fill: 'none',
                                                    pointerEvents: 'painted',
                                                }}
                                            />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row skeleton skeleton--opacity skeleton--static">
                    <div className="col-12">
                        <p className="graphs__label">
                            <span>Heartrate (bpm)</span>
                        </p>
                        <div
                            className="VictoryContainer"
                            style={{
                                height: '100%',
                                width: '100%',
                                userSelect: 'none',
                                pointerEvents: 'none',
                                touchAction: 'none',
                                position: 'relative',
                            }}
                        >
                            <svg
                                width="450"
                                height="80"
                                role="img"
                                viewBox="0 0 450 80"
                                style={{pointerEvents: 'all', width: '100%', height: '100%'}}
                            >
                                <linearGradient id="heartrateGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" stopColor="#DC3545" stopOpacity="0.4"></stop>
                                    <stop offset="100%" stopColor="#DC3545" stopOpacity="0"></stop>
                                </linearGradient>
                                <g role="presentation">
                                    {/* Axes and grid lines */}
                                    <line
                                        x1="20"
                                        x2="450"
                                        y1="60"
                                        y2="60"
                                        style={{stroke: 'rgba(0, 0, 0, 0.1)', fill: 'transparent', strokeWidth: 1}}
                                    />
                                    {/* More lines and ticks as needed */}
                                </g>
                            </svg>
                            <div
                                style={{
                                    zIndex: 99,
                                    position: 'absolute',
                                    top: '0px',
                                    left: '0px',
                                    width: '100%',
                                    height: '100%',
                                }}
                            >
                                <svg
                                    width="450"
                                    height="80"
                                    viewBox="0 0 450 80"
                                    style={{overflow: 'visible', width: '100%', height: '100%'}}
                                >
                                    <g role="presentation">
                                        <line
                                            vectorEffect="non-scaling-stroke"
                                            role="presentation"
                                            shapeRendering="auto"
                                            x1="20"
                                            x2="20"
                                            y1="0"
                                            y2="60"
                                            style={{
                                                stroke: 'rgba(0, 0, 0, 0.1)',
                                                fill: 'transparent',
                                                strokeWidth: 1,
                                                strokeLinecap: 'round',
                                                strokeLinejoin: 'round',
                                            }}
                                        />
                                        <g role="presentation">
                                            <line
                                                vectorEffect="non-scaling-stroke"
                                                role="presentation"
                                                shapeRendering="auto"
                                                x1="20"
                                                x2="450"
                                                y1="60"
                                                y2="60"
                                                style={{
                                                    stroke: 'rgba(0, 0, 0, 0.1)',
                                                    strokeWidth: 1,
                                                    strokeDasharray: 4,
                                                    fill: 'none',
                                                    pointerEvents: 'painted',
                                                }}
                                            />
                                        </g>
                                        <g role="presentation">
                                            <line
                                                vectorEffect="non-scaling-stroke"
                                                role="presentation"
                                                shapeRendering="auto"
                                                x1="20"
                                                x2="450"
                                                y1="41.51162790697674"
                                                y2="41.51162790697674"
                                                style={{
                                                    stroke: 'rgba(0, 0, 0, 0.1)',
                                                    strokeWidth: 1,
                                                    strokeDasharray: 4,
                                                    fill: 'none',
                                                    pointerEvents: 'painted',
                                                }}
                                            />
                                        </g>
                                        <g role="presentation">
                                            <line
                                                vectorEffect="non-scaling-stroke"
                                                role="presentation"
                                                shapeRendering="auto"
                                                x1="20"
                                                x2="450"
                                                y1="23.02325581395349"
                                                y2="23.02325581395349"
                                                style={{
                                                    stroke: 'rgba(0, 0, 0, 0.1)',
                                                    strokeWidth: 1,
                                                    strokeDasharray: 4,
                                                    fill: 'none',
                                                    pointerEvents: 'painted',
                                                }}
                                            />
                                        </g>
                                        <g role="presentation">
                                            <line
                                                vectorEffect="non-scaling-stroke"
                                                role="presentation"
                                                shapeRendering="auto"
                                                x1="20"
                                                x2="450"
                                                y1="4.5348837209302335"
                                                y2="4.5348837209302335"
                                                style={{
                                                    stroke: 'rgba(0, 0, 0, 0.1)',
                                                    strokeWidth: 1,
                                                    strokeDasharray: 4,
                                                    fill: 'none',
                                                    pointerEvents: 'painted',
                                                }}
                                            />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
